export const MINUTE_IN_MILLISECONDS = 60000;
